export const PAST = 'past';
export const PRESENT = 'present';
export const FUTURE = 'future';
export const UNKNOWN = 'unknown';
